import { render, staticRenderFns } from "./ButtonScreenAsset.vue?vue&type=template&id=424aba8d&scoped=true"
import script from "./ButtonScreenAsset.vue?vue&type=script&lang=js"
export * from "./ButtonScreenAsset.vue?vue&type=script&lang=js"
import style0 from "./ButtonScreenAsset.vue?vue&type=style&index=0&id=424aba8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424aba8d",
  null
  
)

export default component.exports